// PricingSection.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
    MdCheck,
    MdArrowForward
} from "react-icons/md";
import "./CheckInLanding.css";

const basicFeatures = [
    "Up to one check-in per day",
    "Three emergency contacts",
    "Alerts to chosen contacts",
    "Pause anytime",
    "15-minute extensions",
];

const premiumFeatures = [
    "Everything in Basic",
    "Unlimited check-ins per day",
    "SMS verification",
    "Priority alert delivery",
    "Trusted contact circles",
];

const PricingSection = () => {
    return (
        <section className="pricing-section" id="pricing">
            <Container>

                <div className="pricing-heading text-center">
                    <p className="pricing-label">— Pricing</p>

                    <h2 className="pricing-title">
                        Peace of mind, <em>priced honestly.</em>
                    </h2>
                </div>

                <Row className="g-4 justify-content-center">

                    {/* Basic */}
                    <Col lg={5} className="mb-lg-0 mb-5">
                        <div className="price-card basic-card">

                            <div className="price-top">
                                <h3>Basic</h3>
                                <span>Everyday</span>
                            </div>

                            <p className="price-desc">
                                For everyday safety and quiet check-ins.
                            </p>

                            <div className="price-value">
                                <strong>$4.99</strong>
                                <small>/month</small>
                            </div>

                            <p className="price-note">
                                or $49/yr — save $11
                            </p>

                            <ul className="price-list">
                                {basicFeatures.map((item, index) => (
                                    <li key={index}>
                                        <MdCheck />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>

                            <a href="#" className="price-btn outline-btn">
                                Get Basic
                            </a>

                        </div>
                    </Col>

                    {/* Premium */}
                    <Col lg={5} >
                        <div className="price-card premium-card">

              <span className="popular-badge">
                Most popular
              </span>

                            <div className="price-top">
                                <h3>Premium</h3>
                                <span>Always-on</span>
                            </div>

                            <p className="price-desc">
                                Faster verification and unlimited check-ins.
                            </p>

                            <div className="price-value">
                                <strong>$9.99</strong>
                                <small>/month</small>
                            </div>

                            <p className="price-note">
                                or $99/yr — save $20
                            </p>

                            <ul className="price-list dark-list">
                                {premiumFeatures.map((item, index) => (
                                    <li key={index}>
                                        <MdCheck />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>

                            <a href="#" className="price-btn premium-btn">
                                Get Premium
                                <MdArrowForward size={18} />
                            </a>

                        </div>
                    </Col>

                </Row>

            </Container>
        </section>
    );
};

export default PricingSection;